/// <amd-module name="Environments/Breadcrumb/EnvironmentsHubBreadcrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

const serviceName = "environments-header-breadcrumb-service";

export interface IEnvironemntBreadcrumbItem {
    name: string;
    url: string;
}

class EnvironmentsHubBreadcrumbService extends VssService implements IBreadcrumbItemService {

    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public addBreadcrumbs(...breadcrumbs: IEnvironemntBreadcrumbItem[]): void {
        this.items.push(...breadcrumbs.map((item, index) => {
            return {
                key: "environments_" + index,
                text: item.name,
                href: item.url,
                onClick: (ev: React.MouseEvent<HTMLElement>) => {
                    this._onFPSClick(item.url, ev);
                }
            } as IBreadcrumbItem
        }));
    }

    private _onFPSClick = (link: string, ev?: React.MouseEvent<HTMLElement>) => {
        onClickFPS(this.pageContext, link, true, ev);
    }
}

Services.add(serviceName, { serviceFactory: EnvironmentsHubBreadcrumbService });

export function addBreadcrumbs(pageContext: IVssPageContext, ...breadcrumbs: IEnvironemntBreadcrumbItem[]): void {
    const breadcrumbService = pageContext.getService<EnvironmentsHubBreadcrumbService>(serviceName);
    breadcrumbService.addBreadcrumbs(...breadcrumbs);
}